import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ReactNode } from "react";
import useLanguage from "hooks/language";

const PUBLIC_STRIPE_KEY = process.env.REACT_APP_PUBLIC_STRIPE_KEY || "null";
export const stripePromise = loadStripe(PUBLIC_STRIPE_KEY);

/**
 * Card Element (tokens) and Express Checkout (PaymentMethods) cannot share
 * one Elements group, and Stripe forbids nesting Elements. Keep this provider
 * as a sibling wrapper only; mount CardElementsProvider around the card form
 * and let ExpressWalletCheckout mount its own payment-mode Elements.
 */
export function StripeProvider({
    children,
}: {
    children: ReactNode;
}): JSX.Element {
    return <>{children}</>;
}

export function CardElementsProvider({
    children,
}: {
    children: ReactNode;
}): JSX.Element {
    const { language } = useLanguage();
    return (
        <Elements stripe={stripePromise} options={{ locale: language }}>
            {children}
        </Elements>
    );
}
